import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'p-toggle',
  templateUrl: './p-toggle.component.html',
  styleUrls: ['./p-toggle.component.scss'],
})
export class PToggleComponent {
  @Input() label!: string;
  @Input() checked = false;
  @Input() disabled = false;
  @Input() onLabel!: string;
  @Input() offLabel!: string;

  @Output() switched = new EventEmitter<boolean>();

  toggleId: string;

  constructor() {
    this.toggleId = 'toggle-' + Math.random().toString(36).substring(2, 9);
  }

  onChange(value: boolean): void {
    if (!this.disabled) {
      this.checked = value;
      this.switched.emit(value);
    }
  }
}
